module.exports = __webpack_public_path__ + "img/img63.38743c44.svg";